module.exports = __webpack_public_path__ + "media/images/times-white-fc40d82a45cf47a3f0d7e0df7bb25978.svg";